import type { FC } from "react";
import { Box } from '@hanzo/ui'

export interface LearnMoreBlockProps {
  title: string;
  description: string;
  image: string;
}

export const LearnMoreBlock: FC<LearnMoreBlockProps> = (props) => {
  const { title, description, image } = props;

  return (
    <Box className="lg:max-w-[300px] 2xl:max-w-[456px] flex-none">
      <Box tag="img" src={image} alt="title" className="w-full h-auto" />
      <Box tag="h1" className="text-white text-[24px] 2xl:text-[32px] mt-8">{title}</Box>
      <Box tag="p" className="mt-[37px] text-grey text-base">{description}</Box>
    </Box>
  )
}